<script>
    import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    fade
} from 'svelte/transition';

import tcLib from '@cclib/lib/timecode.js'
import * as m from '@app/paraglide/messages.js';
let option = $state("tcOfLastEvent"),
    endOfLastEventSec = eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].events.length - 1].end,
    tcOfLastEvent = $state(tcLib.secToTc(endOfLastEventSec+projectState.incode, projectState.frameRate, projectState.dropFrame)),

    refSubA = $state(eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].selected[0]+1 : 1),

    // svelte-ignore state_referenced_locally
    refSubATime = $state(eventGroupState[projectState.selected].events[refSubA-1] ? tcLib.secToTc(eventGroupState[projectState.selected].events[refSubA-1].start, projectState.frameRate, projectState.dropFrame) : "00:00:00:00"),
    // svelte-ignore state_referenced_locally
    refSubB = $state(Math.min(refSubA + 1, eventGroupState[projectState.selected].events.length)),
    // svelte-ignore state_referenced_locally
    refSubBTime = $state(eventGroupState[projectState.selected].events[refSubB-1] ? tcLib.secToTc(eventGroupState[projectState.selected].events[refSubB-1].start, projectState.frameRate, projectState.dropFrame) : "00:00:00:00"),

    startIndex = $state(1),
    endIndex = $state(eventGroupState[projectState.selected].events.length);

function applyTcMultiplier() {
    let multiplier = 100;
    if (option === "tcOfLastEvent") {
        multiplier = (tcLib.tcToSec(tcOfLastEvent, projectState.frameRate, projectState.dropFrame)-projectState.incode) / endOfLastEventSec;
    } else if (option === "increase") {
        multiplier = 1.001;
    } else if (option === "decrease") {
        multiplier = 1.000 / 1.001;
    } else {
        //Calculate multiplier based on reference events timecodes
        let refSubAStart = eventGroupState[projectState.selected].events[refSubA-1].start;
        let refSubBStart = eventGroupState[projectState.selected].events[refSubB-1].start;
        let refSubATimeSec = tcLib.tcToSec(refSubATime, projectState.frameRate, projectState.dropFrame);
        let refSubBTimeSec = tcLib.tcToSec(refSubBTime, projectState.frameRate, projectState.dropFrame);

        /* console.log("Ref A:",refSubAStart, refSubATimeSec);
        console.log("Ref B:",refSubBStart, refSubBTimeSec);
        console.log(refSubATimeSec/refSubAStart);
        console.log(refSubBTimeSec/refSubBStart); */
        multiplier = (((refSubATimeSec/refSubAStart) + (refSubBTimeSec/refSubBStart))/2).toFixed(6);
    }

    // console.log("Multiplier:",multiplier);

    eventGroupState[projectState.selected].events.forEach((event, evIndex, events) => {
        if (!option === "custom" || (evIndex >= startIndex-1 && evIndex <= endIndex-1)){
            events[evIndex].start = event.start * multiplier;
            events[evIndex].end = event.end * multiplier;
        }        
    });

    eventGroupState[projectState.selected].events = eventGroupState[projectState.selected].events;

    insertHistoryAction({
        name: "timecode stretch/shrink", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    
    hideModal();
}

function validateTc(e) {
    tcOfLastEvent = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

function validateTcEventA(e) {
    refSubATime = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

function validateTcEventB(e) {
    refSubBTime = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

function validateStartIndex(){
    if (startIndex > eventGroupState[projectState.selected].events.length){
        startIndex = eventGroupState[projectState.selected].events.length;
    }

    if (startIndex < 1){
        startIndex = 1;
    }    

    if (startIndex > endIndex){
        startIndex = endIndex;
    }
}

function validateEndIndex(){
    if (endIndex > eventGroupState[projectState.selected].events.length){
        endIndex = eventGroupState[projectState.selected].events.length;
    }

    if (endIndex < 1){
        endIndex = 1;
    }

    if (startIndex > endIndex){
        startIndex = endIndex;
    }
}

function frameByFrame(e) {
    if (e.key === "ArrowUp") {
        try {
            let smpteTc = tcLib.createTc(tcOfLastEvent, projectState.frameRate, projectState.dropFrame);
            smpteTc.add(1);
            tcOfLastEvent = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    } else if (e.key === "ArrowDown") {
        try {
            let smpteTc = tcLib.createTc(tcOfLastEvent, projectState.frameRate, projectState.dropFrame);
            smpteTc.subtract(1);
            tcOfLastEvent = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    }
}

function frameByFrameEventA(e) {
    if (e.key === "ArrowUp") {
        try {
            let smpteTc = tcLib.createTc(refSubATime, projectState.frameRate, projectState.dropFrame);
            smpteTc.add(1);
            refSubATime = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    } else if (e.key === "ArrowDown") {
        try {
            let smpteTc = tcLib.createTc(refSubATime, projectState.frameRate, projectState.dropFrame);
            smpteTc.subtract(1);
            refSubATime = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    }
}

function frameByFrameEventB(e) {
    if (e.key === "ArrowUp") {
        try {
            let smpteTc = tcLib.createTc(refSubBTime, projectState.frameRate, projectState.dropFrame);
            smpteTc.add(1);
            refSubBTime = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    } else if (e.key === "ArrowDown") {
        try {
            let smpteTc = tcLib.createTc(refSubBTime, projectState.frameRate, projectState.dropFrame);
            smpteTc.subtract(1);
            refSubBTime = smpteTc.toString();
        } catch (e) {
            console.log(e, e.message);
        }
    }
}

function updateToRefSubA(){
    if (refSubA > eventGroupState[projectState.selected].events.length){
        refSubA = eventGroupState[projectState.selected].events.length;
    }

    if (refSubA < 1){
        refSubA = 1;
    }

    refSubATime = eventGroupState[projectState.selected].events[refSubA-1] ? tcLib.secToTc(eventGroupState[projectState.selected].events[refSubA-1].start, projectState.frameRate, projectState.dropFrame) : "00:00:00:00";
}

function updateToRefSubB(){
    if (refSubB > eventGroupState[projectState.selected].events.length){
        refSubB = eventGroupState[projectState.selected].events.length;
    }

    if (refSubB < 1){
        refSubB = 1;
    }

    refSubBTime = eventGroupState[projectState.selected].events[refSubB-1] ? tcLib.secToTc(eventGroupState[projectState.selected].events[refSubB-1].start, projectState.frameRate, projectState.dropFrame) : "00:00:00:00";

}
</script>

<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'timeStretch' ? 'show d-block' : ''}" role="dialog" aria-labelledby="timeStretchTitle" aria-modal="true" tabindex="-1" id="TimeStretchModal">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="timeStretchTitle">{m.timecode_shrink_stretch()}</h4>
                <button type="button" class="btn-close" aria-label={m.close_time_stretch()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(applyTcMultiplier)}>
                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="tcStretchOption1" 
                                bind:group={option} name="frameRate" value={"tcOfLastEvent"}
                                aria-label={m.set_new_end_time_last_event()}>
                            <label class="form-check-label" for="tcStretchOption1">{m.new_end_time_last_event()}</label>
                        </div>
                        {#if option === "tcOfLastEvent"}
                        <input class="form-control mt-1 w-50" type="text" id="lastEventTc"
                            placeholder={m.smpte_format_placeholder()} 
                            bind:value={tcOfLastEvent} 
                            onblur={validateTc} 
                            onkeydown={frameByFrame} 
                            onfocus={(e)=>{e.target.select()}}
                            aria-label={m.last_event_timecode()}>
                        {/if}
                    </div>

                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="tcStretchOption2" bind:group={option} name="frameRate" value={"increase"}>
                            <label class="form-check-label" for="tcStretchOption2">{m.increase_timecode()}</label>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="tcStretchOption3" bind:group={option} name="frameRate" value={"decrease"}>
                            <label class="form-check-label" for="tcStretchOption3">{m.decrease_timecode()}</label>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="tcStretchOption4" bind:group={option} name="frameRate" value={"custom"}>
                            <label class="form-check-label" for="tcStretchOption4">{m.custom()}</label>
                        </div>
                        {#if option === "custom"}
                        <p class="lead text-warning mb-2">{m.reference_events()}</p>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="input-group">
                                    <span class="input-group-text">{m.event_a()}</span>
                                    <input type="number" class="form-control" bind:value={refSubA} onchange={updateToRefSubA} min=1 max={eventGroupState[projectState.selected].events.length}>
                                    <span class="input-group-text">{m.new_timecode()}</span>
                                    <input type="text" class="form-control" bind:value={refSubATime} onblur={validateTcEventA} onkeydown={frameByFrameEventA} onfocus={(e)=>{e.target.select()}}>
                                </div>
                            </div>
                            <div class="col-12 mb-3">
                                <div class="input-group">
                                    <span class="input-group-text">{m.event_b()}</span>
                                    <input type="number" class="form-control" bind:value={refSubB} onchange={updateToRefSubB} min=1 max={eventGroupState[projectState.selected].events.length}>
                                    <span class="input-group-text">{m.new_timecode()}</span>
                                    <input type="text" class="form-control" bind:value={refSubBTime} onblur={validateTcEventB} onkeydown={frameByFrameEventB} onfocus={(e)=>{e.target.select()}}>
                                </div>
                            </div>
                        </div>
                        <p class="lead text-warning mb-2">{m.event_range()}</p>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <span class="input-group-text">{m.starting_event_id()}</span>
                                    <input type="number" class="form-control" bind:value={startIndex} min=1 max={eventGroupState[projectState.selected].events.length} onblur={validateStartIndex}>
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <span class="input-group-text">{m.ending_event_id()}</span>
                                    <input type="number" class="form-control" bind:value={endIndex} min=1 max={eventGroupState[projectState.selected].events.length} onblur={validateEndIndex}>
                                </div>
                            </div>
                        </div>
                        {/if}
                    </div>

                    <button type="submit" class="btn btn-primary float-end" id="applyStretchBtn" aria-label={m.apply_time_stretch()}>{m.apply()}</button>
                </form>

            </div>
        </div>
    </div>
</div>
